import { BillingPeriod } from "@redotech/redo-model/billing/service-invoice";
import * as z from "zod/v4";

export type ServiceInvoiceStatus = z.infer<typeof serviceInvoiceStatus>;
export const serviceInvoiceStatus = z.object({
  period: z.enum(BillingPeriod),
  creditsForMonth: z.number(),
  creditsSpent: z.number(),
  billingDueDate: z.date(),
  estimatedInvoiceAmount: z.number(),
});

export const getCurrentMarketingEmailInvoice = {
  name: "getCurrentMarketingEmailInvoice" as const,
  input: z.null(),
  output: serviceInvoiceStatus.nullable(),
};
